// extracted by mini-css-extract-plugin
export var formContainer = "_lu-0";
export var message = "_lu-1";